'use strict';

/**
 * contact decorator implementation for the location-finder module.
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.LocationFinder.ContactOverview = T.createDecorator({
	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		this._addressFields.push('headline', 'text', 'job_title', 'mobile');

		// Lifecycle Callback
		this._parent.start(resolve);
	}
});